module.exports = __webpack_public_path__ + "img/portugal-pneumonia-male.7b6dffa6.png";